import React from 'react';
import styled from '@emotion/styled';
import { FaPhoneAlt, FaInstagram } from 'react-icons/fa';

const ContactContainer = styled.div`
  padding: 4rem 2rem;
  max-width: 800px;
  margin: 0 auto;
`;

const Title = styled.h1`
  color: ${props => props.theme.colors.primary};
  font-size: 2.5rem;
  margin-bottom: 2rem;
`;

const InfoList = styled.div`
  margin: 2rem 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const InfoItem = styled.a`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.2rem;
  color: ${props => props.theme.colors.text};
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;

  &:hover {
    color: ${props => props.theme.colors.primary};
  }

  svg {
    font-size: 1.5rem;
    color: ${props => props.theme.colors.primary};
  }
`;

const LinkedInButton = styled.a`
  display: inline-block;
  background-color: #0077B5;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  text-decoration: none;
  font-weight: bold;
  margin-top: 1rem;
`;

const CalendlyContainer = styled.div`
  margin-top: 2rem;
`;

const Contact = () => {
  return (
    <ContactContainer>
      <Title>Contact</Title>

      <InfoList>
        <InfoItem href="tel:+‪13234002243‬">
          <FaPhoneAlt /> +1 ‪(323) 400-2243‬
        </InfoItem>
        <InfoItem href="https://instagram.com/zoetechnologies.la" target="_blank" rel="noopener noreferrer">
          <FaInstagram /> @zoetechnologies.la
        </InfoItem>
      </InfoList>

      <CalendlyContainer>
        <h2>Schedule a Meeting</h2>
        <iframe 
          src="https://calendly.com/osorioelva"
          width="100%"
          height="600"
          frameBorder="0"
        />
      </CalendlyContainer>

      <LinkedInButton
        href="https://www.linkedin.com/in/elva-osorio/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Connect on LinkedIn
      </LinkedInButton>
    </ContactContainer>
  );
};

export default Contact;
